import Api from '@/vuex/api'

import {
  LOAD_SIDEBAR,
  ACTIVE_LINK,
  DISPLAY_SIDEBAR
} from '@/vuex/types'

const api = new Api()

const state = {
  showSidebar: false,
  home: {
    name: 'Home',
    img: 'home-blue.png',
    activeImg: 'home-red.png',
    path: '/dashboard',
    isActive: false
  },
  sidebarLinks: [],
  currentLink: {}
}

const getters = {
  $sidebar () {
    return state
  }
}

const mutations = {
  [ACTIVE_LINK] (state, val) {
    state.currentLink = val
  },
  [LOAD_SIDEBAR] (state, val) {
    state.sidebarLinks = [ state.home, ...val ]
  },
  [DISPLAY_SIDEBAR] (state, val) {
    state.showSidebar = val
  }
}

const actions = {
  async [LOAD_SIDEBAR] (context) {
    let apps = await api.getSidebar()
    context.commit(LOAD_SIDEBAR, apps)
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/sidebar.js